module.exports = __webpack_public_path__ + "img/ERcode.77d46d4b.png";